// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"354":"0d52d0c32c6716728d42","661":"8c8a77047270f4d796f3","838":"8bf88ab482c636e8bdb8"}[chunkId] + ".js";
};